import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { Scope } from '@homejournal/types';
import { useScopes } from './AuthGate';

/** Wraps a route so users lacking the required scope get bounced away. */
export function ScopeGuard({ scope, children }: { scope: Scope; children: ReactNode }) {
  const { has, scopes } = useScopes();
  if (has(scope)) return <>{children}</>;
  // Prefer another authorized destination; fall back to the dashboard (always
  // available) so the user lands somewhere useful instead of a 404 loop.
  const fallback = scopes.length > 0 ? routeForScope(scopes[0]!) : '/dashboard';
  return <Navigate to={fallback} replace />;
}

function routeForScope(scope: Scope): string {
  switch (scope) {
    case 'journal':
      return '/journal';
    case 'expense':
      return '/expenses';
  }
}
